import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from 'styling/GlobalStyles'

export const CancelBtn = ({ onClick }: { onClick?: any }) => {
  const navigate = useNavigate()

  return <Button onClick={() => onClick ? onClick() : navigate(-1)}>Cancel</Button>
}
